import { Card, Text } from "@overmap-ai/blocks"
import { type IssueTypeIdentifierValue, type Stored } from "@overmap-ai/common"
import { selectIssueTypeIdentifierById, selectUserById } from "@overmap-ai/core"
import { memo } from "react"

import { IssueTimelineItemType } from "../../enums/issues"
import { issueTimelineItemTypeData } from "../../mappings/issues"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"
import type { IssueTimelineSize } from "./typings"

interface IssueTimelineIdentifierItemProps {
	issueTypeIdentifierValue: Stored<IssueTypeIdentifierValue>
	size: IssueTimelineSize
}

export const IssueTimelineIdentifierItem = memo<IssueTimelineIdentifierItemProps>((props) => {
	const { issueTypeIdentifierValue, size } = props

	const createdBy = useAppSelector(selectUserById(issueTypeIdentifierValue.created_by ?? -1))
	const identifier = useAppSelector(selectIssueTypeIdentifierById(issueTypeIdentifierValue.issue_type_identifier))!

	const { icon } = issueTimelineItemTypeData[IssueTimelineItemType.IDENTIFIER_VALUE]

	return (
		<div className="flex h-max w-full gap-4">
			<TimelineIconRail icon={icon} size={size} />
			<Card className="flex min-w-0 grow flex-col gap-1" size={size}>
				<Text size={size} accentColor="base">
					<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
					&nbsp;updated identifier
					<Text accentColor="base">
						&nbsp;&#8226;&nbsp;{formatCompactDate(issueTypeIdentifierValue.submitted_at)}
					</Text>
				</Text>
				<Text accentColor="base" className="min-w-0 truncate" size={size}>
					<Text highContrast>{identifier.name}</Text>
					&nbsp;to&nbsp;
					<Text highContrast>{issueTypeIdentifierValue.value}</Text>
				</Text>
			</Card>
		</div>
	)
})
IssueTimelineIdentifierItem.displayName = "IssueIdentifierValueTimelineItem"
